/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.root {
  display: flex;
  flex-direction: column;
  height: 100vh;
  -webkit-user-select: none;
  user-select: none;
}
.root header {
  display: flex;
  flex-direction: column;
}
.root main {
  display: flex;
  justify-content: space-between;
  height: 94vh;
}
.root main > div {
  text-align: center;
  height: 100%;
}
.root main .events,
.root main .actions {
  min-width: 356px;
  flex: 0 0 20%;
  overflow: hidden;
}
.root main .video-player {
  flex-grow: 1;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.1);
  border-width: 0px 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.root main .video-player h2 {
  flex-grow: 1;
  position: relative;
  top: 25%;
}
.root main .video-player .player {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}
.root main .video-player .player .canvas-container {
  width: 90%;
  height: 80%;
  position: relative;
}
.root main .video-player .player .canvas-container > canvas {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.root main .video-player .player .canvas-container > canvas:last-of-type {
  z-index: 2;
}
.root main .video-player .player .audio-subtitle {
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}
.root main .video-player .controls {
  flex: 0 0 7%;
  padding-right: 13px;
  display: flex;
  background: #edeeef;
  width: 100%;
  justify-content: space-between;
}
.root main .video-player .controls .control-button {
  background: #232f3a;
  display: flex;
  flex-direction: row;
  gap: 12px;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  align-items: center;
  justify-content: space-evenly;
  flex-shrink: 0;
  width: max-content;
  padding: 2px 5px;
  height: 24px;
  min-width: 30px;
}
.root main .video-player .controls .control-button span {
  color: rgb(255, 255, 255);
  text-align: center;
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  text-transform: uppercase;
}
.root main .video-player .controls > div {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}
.root main .video-player .controls .ot-et {
  flex: 0 0 18%;
}
.root main .video-player .controls .segments {
  flex: 0 0 10%;
}
.root main .video-player .controls .video-controls {
  flex-grow: 1;
}
.root main .video-player .controls .zoom-controls {
  flex: 0 0 25%;
}
/*# sourceMappingURL=content-control-studio.component.css.map */
